// Screen 7 — Allergies (wizard step 6 of 9). "None" mutex.
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WizardScreen } from '../../components/planner/WizardScreen';
import { CheckboxList } from '../../components/planner/CheckboxList';
import { FieldError } from '../../components/planner/FieldError';
import { useDraft, STEP_ROUTES } from '../../lib/plannerDraft';

const ALLERGIES = [
  { id: 'none', label: 'None' },
  { id: 'gluten', label: 'Gluten' },
  { id: 'dairy', label: 'Dairy' },
  { id: 'eggs', label: 'Eggs' },
  { id: 'soy', label: 'Soy' },
  { id: 'tree_nuts', label: 'Tree nuts' },
  { id: 'peanuts', label: 'Peanuts' },
  { id: 'fish', label: 'Fish' },
  { id: 'shellfish', label: 'Shellfish' },
  { id: 'sesame', label: 'Sesame' },
  { id: 'other', label: 'Other' },
];

export default function Step7Allergies() {
  const nav = useNavigate();
  const { draft, patch, bump } = useDraft();
  const [showErr, setShowErr] = useState(false);

  const showOther = draft.allergies.includes('other');
  const needsOtherText =
    showOther && !draft.allergies_other_description.trim();

  const valid =
    Array.isArray(draft.allergies) &&
    draft.allergies.length > 0 &&
    !needsOtherText;

  const onContinue = () => {
    if (!valid) { setShowErr(true); return; }
    bump(7);
    nav(STEP_ROUTES[7]);
  };

  return (
    <WizardScreen
      step={6}
      eyebrow="Allergies"
      title="Any allergies?"
      canContinue={valid}
      onContinue={onContinue}
    >
      <p className="text-sm mb-5" style={{ color: 'var(--text-dim)' }}>
        We&apos;ll exclude any meal that contains these. If you have no
        allergies, choose <strong>None</strong>.
      </p>

      <CheckboxList
        options={ALLERGIES}
        value={draft.allergies}
        mutexId="none"
        onChange={(v) => patch({ allergies: v }, { invalidateGeneration: true })}
        ariaLabel="Allergies"
        testIdPrefix="allergy"
      />

      {showOther && (
        <label className="block mt-4">
          <span className="font-display uppercase tracking-wider text-sm">
            Please describe (optional detail)
          </span>
          <input
            type="text"
            maxLength={120}
            value={draft.allergies_other_description}
            onChange={(e) => patch({ allergies_other_description: e.target.value }, { invalidateGeneration: true })}
            data-testid="allergy-other-desc-input"
            className="mt-2 w-full"
            style={{
              padding: '12px 14px',
              border: '1.5px solid var(--line)',
              borderRadius: 'var(--radius)',
              background: '#fff',
              fontSize: '16px',
            }}
          />
          <div className="mt-1 text-xs" style={{ color: 'var(--text-dim)' }}>
            {draft.allergies_other_description.length}/120
          </div>
        </label>
      )}

      <FieldError id="allergy-error">
        {showErr && !valid
          ? needsOtherText
            ? 'Please add a short description for "Other".'
            : 'Please choose at least one option. If you have no allergies, select None.'
          : null}
      </FieldError>
    </WizardScreen>
  );
}
